<template>
	<div style="padding-top: 10px;padding-bottom: 50px;">
		<h1 style="font-size: 40px;text-align: center;margin-bottom: 25px;margin-top: 8px;">其他页面内容设置</h1>

		<el-descriptions title="各首页背景" style="margin-top: 20px;" :column="2" size="40" border :contentStyle="rowCenter"
			:labelStyle="rowCenter">
			<template slot="extra">
				<el-button type="primary" size="small" @click="eidt(7)">编辑</el-button>
			</template>
			<el-descriptions-item v-for="(item,index) in fifthTitle" :key="index">
				<template slot="label">
					{{item.title}}
				</template>
				<el-image v-if="item.contentType == 2 && item.content != ''" style="width: 50px;height: 50px;" :src="item.content"
					@click="setImage1(item.content)" :preview-src-list="fifthImageUrl">
				</el-image>
				<span v-else>{{ item.content}} </span>
			</el-descriptions-item>

		</el-descriptions>

		<el-descriptions title="合作伙伴" :column="2" size="40" border :contentStyle="rowCenter" :labelStyle="rowCenter"
			style="margin-top: 20px;">
			<template slot="extra">
				<el-button type="primary" size="small" @click="eidt(1)">编辑</el-button>
			</template>
			<el-descriptions-item>
				<template slot="label">
					图片
				</template>
				<label v-for="(item,index) in imageList" :key="index" style="margin-left: 10px;">
					<el-image style="width: 90px;height: 30px;" :src="item" @click="setImage(item)"
						:preview-src-list="imageList">
					</el-image>
				</label>
			</el-descriptions-item>

		</el-descriptions>

		<el-descriptions title="资源首页" style="margin-top: 20px;" :column="2" size="40" border :contentStyle="rowCenter"
			:labelStyle="rowCenter">
			<template slot="extra">
				<el-button type="primary" size="small" @click="eidt(2)">编辑</el-button>
			</template>
			<el-descriptions-item v-for="(item,index) in secondTitle" :key="index">
				<template slot="label">
					{{item.title}}
				</template>
				<el-image v-if="item.contentType == 2" style="width: 50px;height: 50px;" :src="item.content"
					@click="setImage(item.content)" :preview-src-list="fourthImageUrl">
				</el-image>
				<span v-else>{{ item.content}} </span>
			</el-descriptions-item>


		</el-descriptions>

		<el-descriptions title="失效模式首页" style="margin-top: 20px;" :column="2" size="40" border :contentStyle="rowCenter"
			:labelStyle="rowCenter">
			<template slot="extra">
				<el-button type="primary" size="small" @click="eidt(3)">编辑</el-button>
			</template>
			<el-descriptions-item v-for="(item,index) in failureTitle" :key="index">
				<template slot="label">
					{{item.title}}
				</template>
				<el-image v-if="item.contentType == 2" style="width: 50px;height: 50px;" :src="item.content"
					@click="setImage(item.content)" :preview-src-list="failureImageUrl">
				</el-image>
				<span v-else>{{ item.content}} </span>
			</el-descriptions-item>


		</el-descriptions>

		<el-descriptions title="办事处首页" style="margin-top: 20px;" :column="2" size="40" border :contentStyle="rowCenter"
			:labelStyle="rowCenter">
			<template slot="extra">
				<el-button type="primary" size="small" @click="eidt(4)">编辑</el-button>
			</template>
			<el-descriptions-item v-for="(item,index) in officeTitle" :key="index">
				<template slot="label">
					{{item.title}}
				</template>
				<el-image v-if="item.contentType == 2" style="width: 50px;height: 50px;" :src="item.content"
					@click="setImage(item.content)" :preview-src-list="officeImageUrl">
				</el-image>
				<span v-else>{{ item.content}} </span>
			</el-descriptions-item>


		</el-descriptions>

		<el-descriptions title="为什么加入我们首页" style="margin-top: 20px;" :column="2" size="40" border
			:contentStyle="rowCenter" :labelStyle="rowCenter">
			<template slot="extra">
				<el-button type="primary" size="small" @click="eidt(5)">编辑</el-button>
			</template>
			<el-descriptions-item v-for="(item,index) in thirdTitle" :key="index">
				<template slot="label">
					{{item.title}}
				</template>
				<span>{{ item.content}} </span>
			</el-descriptions-item>


		</el-descriptions>

		<el-descriptions title="质量与合规首页" style="margin-top: 20px;" :column="2" size="40" border
			:contentStyle="rowCenter" :labelStyle="rowCenter">
			<template slot="extra">
				<el-button type="primary" size="small" @click="eidt(6)">编辑</el-button>
			</template>
			<el-descriptions-item v-for="(item,index) in fourthTitle" :key="index">
				<template slot="label">
					{{item.title}}
				</template>
				<el-image v-if="item.contentType == 2" style="width: 50px;height: 50px;" :src="item.content"
					@click="setImage(item.content)" :preview-src-list="fourthImageUrl">
				</el-image>
				<span v-else>{{ item.content}} </span>
			</el-descriptions-item>

		</el-descriptions>



		<el-dialog title="修改信息" :visible.sync="firstDialogVisible" width="60%" center>
			<el-form ref="form" :model="firstform" label-width="80px">

				<el-form-item label="合作伙伴" prop="subtitle">
					<el-upload :action="uploadUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
						:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :file-list="imageList1"
						:on-remove="handleRemove">
						<i class="el-icon-plus"></i>
					</el-upload>
					<el-dialog :visible.sync="dialogVisible">
						<img width="100%" :src="dialogImageUrl" alt="">
					</el-dialog>
				</el-form-item>

			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="firstDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save(1)">{{ btnText }}</el-button>
			</span>
		</el-dialog>

		<el-dialog title="修改信息" :visible.sync="secondDialogVisible" width="60%" center>
			<el-form ref="form" :model="secondform" label-width="80px">

				<div v-for="(item,index) in secondTitle" :key="index">
					<el-form-item :label="item.title" prop="title" label-width="200px;" v-if="item.contentType == 1">
						<el-col :span="15" style="border: 1px solid gray;">
							<!-- <el-input v-model="secondTitle[index].content"></el-input> -->
							<tinymce-editor v-model="secondTitle[index].content" :init="initEditor" />
						</el-col>
					</el-form-item>

				</div>

			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="secondDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save(2)">{{ btnText }}</el-button>
			</span>
		</el-dialog>

		<el-dialog title="修改信息" :visible.sync="failureDialogVisible" width="60%" center>
			<el-form ref="form" :model="failureform" label-width="80px">

				<div v-for="(item,index) in failureTitle" :key="index">
					<el-form-item :label="item.title" prop="title" label-width="200px;" v-if="item.contentType == 1">
						<el-col :span="15" style="border: 1px solid gray;">
							<!-- <el-input v-model="sixthTitle[index].content"></el-input> -->
							<tinymce-editor v-model="failureTitle[index].content" :init="initEditor" />
						</el-col>
					</el-form-item>

				</div>

			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="failureDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save(3)">{{ btnText }}</el-button>
			</span>
		</el-dialog>

		<el-dialog title="修改信息" :visible.sync="officeDialogVisible" width="60%" center>
			<el-form ref="form" :model="officeform" label-width="80px">

				<div v-for="(item,index) in officeTitle" :key="index">
					<el-form-item :label="item.title" prop="title" label-width="200px;" v-if="item.contentType == 1">
						<el-col :span="15" style="border: 1px solid gray;">
							<!-- <el-input v-model="sixthTitle[index].content"></el-input> -->
							<tinymce-editor v-model="officeTitle[index].content" :init="initEditor" />
						</el-col>
					</el-form-item>

				</div>

			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="officeDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save(4)">{{ btnText }}</el-button>
			</span>
		</el-dialog>

		<el-dialog title="修改信息" :visible.sync="thirdDialogVisible" width="60%" center>
			<el-form ref="form" :model="thirdform" label-width="80px">

				<div v-for="(item,index) in thirdTitle" :key="index">
					<el-form-item :label="item.title" prop="title" label-width="200px;" v-if="item.contentType == 1">
						<el-col :span="15" style="border: 1px solid gray;">
							<!-- <el-input v-model="sixthTitle[index].content"></el-input> -->
							<tinymce-editor v-model="thirdTitle[index].content" :init="initEditor" />
						</el-col>
					</el-form-item>

				</div>

			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="thirdDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save(5)">{{ btnText }}</el-button>
			</span>
		</el-dialog>

		<el-dialog title="修改信息" :visible.sync="fourthDialogVisible" width="60%" center>
			<el-form ref="form" :model="fourthform" label-width="80px">

				<div v-for="(item,index) in fourthTitle" :key="index">
					<el-form-item :label="item.title" prop="title" label-width="200px;" v-if="item.contentType == 1">
						<el-col :span="15" style="border: 1px solid gray;">
							<!-- <el-input v-model="sixthTitle[index].content"></el-input> -->
							<tinymce-editor v-model="fourthTitle[index].content" :init="initEditor" />
						</el-col>
					</el-form-item>

					<el-form-item :label="item.title" prop="title" label-width="200px;" v-else>
						<el-col :span="15" v-if="item.title == '生产环境图片'">
							<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
								:on-success="handleAvatarSuccess1" :before-upload="beforeAvatarUpload1">
								<img v-if="fourthTitle[index].content" :src="fourthTitle[index].content" class="avatar">
								<i v-else class="el-icon-plus"></i>
							</el-upload>
						</el-col>
						<el-col :span="15" v-if="item.title == '生产环境图片1'">
							<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
								:on-success="handleAvatarSuccess2" :before-upload="beforeAvatarUpload2">
								<img v-if="fourthTitle[index].content" :src="fourthTitle[index].content" class="avatar">
								<i v-else class="el-icon-plus"></i>
							</el-upload>
						</el-col>
						<el-col :span="15" v-if="item.title == '生产环境图片2'">
							<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
								:on-success="handleAvatarSuccess3" :before-upload="beforeAvatarUpload3">
								<img v-if="fourthTitle[index].content" :src="fourthTitle[index].content" class="avatar">
								<i v-else class="el-icon-plus"></i>
							</el-upload>
						</el-col>
						<el-col :span="15" v-if="item.title == '生产环境图片3'">
							<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
								:on-success="handleAvatarSuccess4" :before-upload="beforeAvatarUpload4">
								<img v-if="fourthTitle[index].content" :src="fourthTitle[index].content" class="avatar">
								<i v-else class="el-icon-plus"></i>
							</el-upload>
						</el-col>
					</el-form-item>

				</div>

			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="fourthDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save(6)">{{ btnText }}</el-button>
			</span>
		</el-dialog>


		<el-dialog title="修改信息" :visible.sync="fifthDialogVisible" width="60%" center>

			<el-form ref="form" :model="fifthform" label-width="80px">



				<div v-for="(item,index) in fifthTitle" :key="index">

					<el-form-item :label="item.title" prop="title" label-width="200px;" v-if="item.contentType == 1">

						<el-col :span="15" style="border: 1px solid gray;">

							<!-- <el-input v-model="sixthTitle[index].content"></el-input> -->

							<tinymce-editor v-model="fifthTitle[index].content" :init="initEditor" />

						</el-col>

					</el-form-item>



					<el-form-item :label="item.title" prop="title" label-width="200px;" v-else>

						<el-col :span="15">

							<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
								:on-success="(res,file)=>handleAvatarSuccess5(index,res,file)"
								:before-upload="beforeAvatarUpload5">

								<img v-if="fifthTitle[index].content" :src="fifthTitle[index].content" class="avatar">

								<i v-else class="el-icon-plus"></i>

							</el-upload>

						</el-col>

					</el-form-item>



				</div>



			</el-form>

			<span slot="footer" class="dialog-footer">

				<el-button @click="fourthDialogVisible = false">取 消</el-button>

				<el-button type="primary" @click="save(7)">{{ btnText }}</el-button>

			</span>

		</el-dialog>

	</div>
</template>

<script>
	import TinymceEditor from '../../components/TinymceEditor/index.vue';
	import utils from '../../utils/utils.js'
	export default {
		name: "Home",
		components: {
			TinymceEditor
		},
		data() {
			return {
				dialogImageUrl: '',
				dialogVisible: false,
				uploadUrl: "https://zyjwsys.sxsla.cn/files/upload",
				user: JSON.parse(sessionStorage.getItem('CurUser')),
				rowCenter: {
					"text-align": "center"
				},
				imageList: [],
				imageList1: [],
				firstDialogVisible: false,
				firstData: [],
				firstform: {
					sub_title: "",
					sub_title1: "",
					title: "",
					title1: ""
				},
				secondDialogVisible: false,
				secondTitle: [{
						"title": "小标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "小标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "大标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "大标题(英文)",
						"content": "",
						"contentType": 1
					}
				],
				secondform: {

				},
				secondImageUrl: ["https://xlhzfile.sxsla.cn/files/2z1e0igo.png"],
				failureData: [],
				failureDialogVisible: false,
				failureTitle: [{
						"title": "小标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "小标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "大标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "大标题(英文)",
						"content": "",
						"contentType": 1
					}
				],
				failureform: {

				},
				failureImageUrl: [],
				officeData: [],
				officeDialogVisible: false,
				officeTitle: [{
						"title": "小标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "小标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "大标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "大标题(英文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "内容(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "内容(英文)",
						"content": "",
						"contentType": 1
					}
				],
				officeform: {

				},
				officeImageUrl: [],
				thirdDialogVisible: false,
				thirdTitle: [{
						"title": "标题(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "内容(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "内容(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "按钮(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "按钮1(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第一模块小标题(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第一模块小标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第一模块标题(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第一模块标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第二模块小标题(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第二模块小标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第二模块标题(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第二模块标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第二模块内容(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第二模块内容(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第三模块小标题(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第三模块小标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第三模块标题(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第三模块标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第三模块列表标题(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第三模块列表标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第三模块列表内容(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第三模块列表内容(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第三模块列表标题1(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第三模块列表标题1(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第三模块列表内容1(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第三模块列表内容1(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第三模块列表标题2(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第三模块列表标题2(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第三模块列表内容2(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第三模块列表内容2(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第三模块列表标题3(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第三模块列表标题3(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第三模块列表内容3(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第三模块列表内容3(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第四模块标题(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第四模块标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第四模块内容(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第四模块内容(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第五模块标题(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第五模块标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第五模块内容(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第五模块内容(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第五模块按钮(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第五模块按钮(英文)",
						"content": "",
						"contentType": 1
					}
				],
				thirdData: [],
				thirdform: {},
				fourthDialogVisible: false,
				fourthTitle: [{
						"title": "标题(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第一模块小标题(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第一模块小标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第一模块标题(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第一模块标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第一模块内容(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第一模块内容(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第二模块小标题(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第二模块小标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第二模块标题(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "第二模块标题(英文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "生产环境图片",
						"content": "",
						"contentType": 2
					}, {
						"title": "生产环境图片1",
						"content": "",
						"contentType": 2
					}, {
						"title": "生产环境图片2",
						"content": "",
						"contentType": 2
					}, {
						"title": "生产环境图片3",
						"content": "",
						"contentType": 2
					}

				],
				fourthData: [],
				fourthform: {
					title: "",
					content: "",
					btn: ""
				},
				fourthImageUrl: [],
				fifthDialogVisible: false,
				fifthTitle: [{
					"title": "行业应用首页背景图片",
					"content": "",
					"contentType": 2
				}, {
					"title": "产品首页背景图片",
					"content": "",
					"contentType": 2
				}, {
					"title": "资源首页背景图片",
					"content": "",
					"contentType": 2
				}, {
					"title": "关于我们首页背景图片",
					"content": "",
					"contentType": 2
				}, {
					"title": "失效模式首页背景图片",
					"content": "",
					"contentType": 2
				}, {
					"title": "案例首页背景图片",
					"content": "",
					"contentType": 2
				}, {
					"title": "知识库首页背景图片",
					"content": "",
					"contentType": 2
				}, {
					"title": "为什么加入我们首页背景图片",
					"content": "",
					"contentType": 2
				}, {
					"title": "求职机会首页背景图片",
					"content": "",
					"contentType": 2
				}, {
					"title": "办事处首页背景图片",
					"content": "",
					"contentType": 2
				}, {
					"title": "新闻首页背景图片",
					"content": "",
					"contentType": 2
				}, {
					"title": "质量与合规首页背景图片",
					"content": "",
					"contentType": 2
				}],
				fifthData: [],
				fifthform: {
					title: "",
					content: "",
					btn: ""
				},
				fifthImageUrl: [],
				btnText: "提 交",
			}
		},
		beforeMount() {
			this.secondData = [];

			for (var i = 0; i < this.secondTitle.length; i++) {
				if (i % 2 != 0) {
					var bean = {
						id: "",
						title: "resource_title" + (i + 1),
						content: "",
						contentType: this.secondTitle[i].contentType,
						contentEg: "",
						type: "other_resource"
					}
					this.secondData.push(bean);
				}
				this.$set(this.secondform, 'title' + (i + 1), '');
			}

			this.failureData = [];
			for (var i = 0; i < this.failureTitle.length; i++) {
				if (i % 2 != 0) {
					var bean = {
						id: "",
						title: "failure_title" + (i + 1),
						content: "",
						contentType: this.failureTitle[i].contentType,
						contentEg: "",
						type: "other_failure"
					}
					this.failureData.push(bean);
				}
				this.$set(this.failureform, 'title' + (i + 1), '');
			}

			this.officeData = [];
			for (var i = 0; i < this.officeTitle.length; i++) {
				if (i % 2 != 0) {
					var bean = {
						id: "",
						title: "office_title" + (i + 1),
						content: "",
						contentType: this.officeTitle[i].contentType,
						contentEg: "",
						type: "other_office"
					}
					this.officeData.push(bean);
				}
				this.$set(this.officeform, 'title' + (i + 1), '');
			}

			this.thirdData = [];
			for (var i = 0; i < this.thirdTitle.length; i++) {
				if (i % 2 != 0) {
					var bean = {
						id: "",
						title: "other_why_title" + (i + 1),
						content: "",
						contentType: this.thirdTitle[i].contentType,
						contentEg: "",
						type: "other_why"
					}
					this.thirdData.push(bean);
				}
				this.$set(this.thirdform, 'title' + (i + 1), '');
			}

			this.fourthData = [];
			for (var i = 0; i < this.fourthTitle.length; i++) {
				if (i % 2 != 0) {
					var bean = {
						id: "",
						title: "other_quality_title" + (i + 1),
						content: "",
						contentType: this.fourthTitle[i].contentType,
						contentEg: "",
						type: "other_quality"
					}
					this.fourthData.push(bean);
				}
				this.$set(this.fourthform, 'title' + (i + 1), '');
			}

			this.fifthData = [];
			for (var i = 0; i < this.fifthTitle.length; i++) {
				if (i % 2 != 0) {
					var bean = {
						id: "",
						title: "other_bg_title" + (i + 1),
						content: "",
						contentType: this.fifthTitle[i].contentType,
						contentEg: "",
						type: "other_bg"
					}
					this.fifthData.push(bean);
				}
				this.$set(this.fifthform, 'title' + (i + 1), '');
			}


			// console.log("11--" + JSON.stringify(this.secondData));
			this.getData();
		},
		computed: {
			// 初始化富文本
			initEditor() {
				return {
					height: 300,
					branding: false,
					skin_url: '/tinymce/skins/ui/oxide',
					content_css: '/tinymce/skins/content/default/content.css',
					language_url: '/tinymce/langs/zh_CN.js',
					language: 'zh_CN',
					plugins: 'code print preview fullscreen paste searchreplace save autosave link autolink image imagetools media table codesample lists advlist hr charmap emoticons anchor directionality pagebreak quickbars nonbreaking visualblocks visualchars wordcount',
					toolbar: 'fullscreen preview code | undo redo | forecolor backcolor | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | formatselect fontselect fontsizeselect | link image media emoticons charmap anchor pagebreak codesample | ltr rtl',
					toolbar_drawer: 'sliding',
					fontsize_formats: '8px 10px 12px 14px 18px 24px 36px 48px 60px 72px 80px 90px 100px 110px 120px 140px 180px',
					images_upload_handler: (blobInfo, success, error) => {
						let file = blobInfo.blob();
						// 使用axios上传
						const formData = new FormData();
						formData.append('file', file, file.name);
						this.$http.post('https://zyjwsys.sxsla.cn/files/upload', formData).then(res => {
							if (res.data.code == 0) {
								success(res.data.data);
							} else {
								error(res.data.msg);
							}
						}).catch(e => {
							console.error(e);
							error(e.message);
						});
					},
					file_picker_types: 'media',
					file_picker_callback: () => {}
				}
			}
		},

		methods: {
			handleRemove(file, fileList) {
				this.imageList = this.imageList.filter(item => !item.includes(file.name));
				// console.log("2222---", JSON.stringify(this.imageList));
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			save(type) {
				var that = this;
				// console.log("11--" + this.dialogImageUrl);
				if (type == 1) {
					var params = [{
						id: 236,
						title: "hzhb",
						content: this.imageList.join(","),
						contentEg: "",
						type: "other"
					}];
					this.utils.requestPost(this, "/content/add", params, function(res, total) {
						that.utils.showMessage("success", "保存成功");
						that.firstDialogVisible = false;
						that.getData();
					});
				} else if (type == 2) {
					for (var i = 0; i < this.secondData.length; i++) {
						var bean = this.secondData[i];
						var j = i * 2;
						bean.content = this.secondTitle[j].content;
						bean.contentEg = this.secondTitle[j + 1].content;
						bean.id = this.secondTitle[j].id;
					}
					// console.log("22---" + JSON.stringify(this.secondData))
					this.utils.requestPost(this, "/content/add", this.secondData, function(res, total) {
						that.utils.showMessage("success", "保存成功");
						that.secondDialogVisible = false;
						that.getData();
					});
				} else if (type == 3) {

					for (var i = 0; i < this.failureData.length; i++) {
						var bean = this.failureData[i];
						var j = i * 2;
						bean.content = this.failureTitle[j].content;
						bean.contentEg = this.failureTitle[j + 1].content;
						bean.id = this.failureTitle[j].id;
					}
					this.utils.requestPost(this, "/content/add", this.failureData, function(res, total) {
						that.utils.showMessage("success", "保存成功");
						that.failureDialogVisible = false;
						that.getData();
					});
				} else if (type == 4) {

					for (var i = 0; i < this.officeData.length; i++) {
						var bean = this.officeData[i];
						var j = i * 2;
						bean.content = this.officeTitle[j].content;
						bean.contentEg = this.officeTitle[j + 1].content;
						bean.id = this.officeTitle[j].id;
					}
					this.utils.requestPost(this, "/content/add", this.officeData, function(res, total) {
						that.utils.showMessage("success", "保存成功");
						that.officeDialogVisible = false;
						that.getData();
					});
				} else if (type == 5) {

					for (var i = 0; i < this.thirdData.length; i++) {
						var bean = this.thirdData[i];
						var j = i * 2;
						bean.content = this.thirdTitle[j].content;
						bean.contentEg = this.thirdTitle[j + 1].content;
						bean.id = this.thirdTitle[j].id;
					}
					this.utils.requestPost(this, "/content/add", this.thirdData, function(res, total) {
						that.utils.showMessage("success", "保存成功");
						that.thirdDialogVisible = false;
						that.getData();
					});
				} else if (type == 6) {
					for (var i = 0; i < this.fourthData.length; i++) {
						var bean = this.fourthData[i];
						var j = i * 2;
						bean.content = this.fourthTitle[j].content;
						bean.contentEg = this.fourthTitle[j + 1].content;
						bean.id = this.fourthTitle[j].id;
					}
					this.utils.requestPost(this, "/content/add", this.fourthData, function(res, total) {
						that.utils.showMessage("success", "保存成功");
						that.fourthDialogVisible = false;
						that.getData();
					});
				} else if (type == 7) {
					for (var i = 0; i < this.fifthData.length; i++) {
						var bean = this.fifthData[i];
						var j = i * 2;
						bean.content = this.fifthTitle[j].content;
						bean.contentEg = this.fifthTitle[j + 1].content;
						bean.id = this.fifthTitle[j].id;
					}
					this.utils.requestPost(this, "/content/add", this.fifthData, function(res, total) {
						that.utils.showMessage("success", "保存成功");
						that.fifthDialogVisible = false;
						that.getData();
					});
				}





			},
			eidt(type) {
				if (type == 1) {
					this.firstDialogVisible = true;
				} else if (type == 2) {
					this.secondDialogVisible = true;
				} else if (type == 3) {
					this.failureDialogVisible = true;
				} else if (type == 4) {
					this.officeDialogVisible = true;
				} else if (type == 5) {
					this.thirdDialogVisible = true;
				} else if (type == 6) {
					this.fourthDialogVisible = true;
				} else if (type == 7) {
					this.fifthDialogVisible = true;
				}
			},
			getData() {
				var that = this;
				var params = {
					"param": {
						'type': 'other'
					}
				};

				this.utils.requestPost(this, '/content/getDataList', params, function(res, total) {
					that.firstData = [];
					var j = 0;
					var k = 0;
					var m = 0;
					var n = 0;
					var x = 0;
					var y = 0;
					var p = 0;
					for (var i = 0; i < res.length; i++) {
						var bean = res[i];
						if (bean.title == 'hzhb') {
							that.imageList = bean.content.split(",");
							// console.log("22--" + JSON.stringify(that.imageList))
							that.imageList1 = [];
							for (var j = 0; j < that.imageList.length; j++) {
								var imageBean = that.imageList[j]
								let index = imageBean.indexOf("files/");
								if (index !== -1) {
									let resultStr = imageBean.substring(index, imageBean.length);
									that.imageList1.push({
										name: resultStr,
										url: imageBean
									})
								}

							}

						} else if (bean.type == 'other_resource') {
							that.secondTitle[k].id = bean.id;
							that.secondTitle[k].content = bean.content;
							that.secondTitle[k + 1].id = bean.id;
							that.secondTitle[k + 1].content = bean.contentEg;
							k = k + 2;
						} else if (bean.type == 'other_failure') {
							that.failureTitle[m].id = bean.id;
							that.failureTitle[m].content = bean.content;
							that.failureTitle[m + 1].id = bean.id;
							that.failureTitle[m + 1].content = bean.contentEg;
							m = m + 2;
						} else if (bean.type == 'other_office') {
							that.officeTitle[n].id = bean.id;
							that.officeTitle[n].content = bean.content;
							that.officeTitle[n + 1].id = bean.id;
							that.officeTitle[n + 1].content = bean.contentEg;
							n = n + 2;
						} else if (bean.type == 'other_why') {
							that.thirdTitle[x].id = bean.id;
							that.thirdTitle[x].content = bean.content;
							that.thirdTitle[x + 1].id = bean.id;
							that.thirdTitle[x + 1].content = bean.contentEg;
							x = x + 2;
						} else if (bean.type == 'other_quality') {
							that.fourthTitle[y].id = bean.id;
							that.fourthTitle[y].content = bean.content;
							that.fourthTitle[y + 1].id = bean.id;
							that.fourthTitle[y + 1].content = bean.contentEg;
							y = y + 2;
						} else if (bean.type == 'other_bg') {
							that.fifthTitle[p].id = bean.id;
							that.fifthTitle[p].content = bean.content;
							that.fifthTitle[p + 1].id = bean.id;
							that.fifthTitle[p + 1].content = bean.contentEg;
							p = p + 2;
						}


					}
				});



			},
			setImage(url) {
				this.fourthImageUrl = [];
				this.fourthImageUrl.push(url);
			},
			
			setImage1(url) {
				this.fifthImageUrl = [];
				this.fifthImageUrl.push(url);
			},
			handleAvatarSuccess(res, file, item) {

				this.imageList.push("https://image.sxsla.cn/files/" + res.data.name);
				// console.log("222---" + JSON.stringify(this.imageList));
				// this.secondTitle[24].content = URL.createObjectURL(file.raw);
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 2;

				// if (!isJPG) {
				// 	this.$message.error('上传头像图片只能是 JPG 格式!');
				// }
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
				}

				return isJPG && isLt2M;
			},
			handleAvatarSuccess1(res, file, item) {
				this.fourthTitle[12].content = "https://image.sxsla.cn/files/" + res.data.name;
			},
			beforeAvatarUpload1(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 2;

				// if (!isJPG) {
				// 	this.$message.error('上传头像图片只能是 JPG 格式!');
				// }
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
				}

				return isJPG && isLt2M;
			},
			handleAvatarSuccess2(res, file, item, index) {
				this.fourthTitle[13].content = "https://image.sxsla.cn/files/" + res.data.name;
			},
			beforeAvatarUpload2(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 2;

				// if (!isJPG) {
				// 	this.$message.error('上传头像图片只能是 JPG 格式!');
				// }
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
				}

				return isJPG && isLt2M;
			},
			handleAvatarSuccess3(res, file, item, index) {
				this.fourthTitle[14].content = "https://image.sxsla.cn/files/" + res.data.name;
			},
			beforeAvatarUpload3(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 2;

				// if (!isJPG) {
				// 	this.$message.error('上传头像图片只能是 JPG 格式!');
				// }
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
				}

				return isJPG && isLt2M;
			},
			handleAvatarSuccess4(res, file) {
				this.fourthTitle[15].content = "https://image.sxsla.cn/files/" + res.data.name;
			},
			beforeAvatarUpload4(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 2;

				// if (!isJPG) {
				// 	this.$message.error('上传头像图片只能是 JPG 格式!');
				// }
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
				}

				return isJPG && isLt2M;
			},

			handleAvatarSuccess5(index, res, file) {
				this.fifthTitle[index].content = "https://image.sxsla.cn/files/" + res.data.name;
			},
			beforeAvatarUpload5(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 20;

				// if (!isJPG) {
				// 	this.$message.error('上传头像图片只能是 JPG 格式!');
				// }
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 20MB!');
				}

				return isJPG && isLt2M;
			},
		}
	}
</script>

<style scoped>
	.avatar {
		width: 160px;
		height: 160px;
	}
</style>
